import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("01b907472b", "._5e3c1ad013fd5711__container{height:100%;min-height:0}");
}
export default {"container":"_5e3c1ad013fd5711__container"};
